import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { auth, functions } from '../firebase'; // Import functions
import { httpsCallable } from 'firebase/functions'; // Import for calling cloud functions
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faSync, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

function OrgIdRequiredPrompt() {
  const { currentUser } = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [error, setError] = useState('');

  const handleRefresh = async () => {
    if (!currentUser) return;

    setIsRefreshing(true);
    setError('');

    try {
      // 1. Call the cloud function to attempt to set the user's custom claims
      console.log('OrgIdRequiredPrompt: Calling addClaimCreds function...');
      const addClaimCredsFn = httpsCallable(functions, 'addClaimCreds');
      await addClaimCredsFn();

      // 2. Force a refresh of the user's ID token to get the new claims
      console.log('OrgIdRequiredPrompt: Forcing ID token refresh...');
      await currentUser.getIdToken(true);

      // 3. Reload the page. The ProtectedRoute will re-evaluate and grant access
      // if the userOrgId claim is now present.
      window.location.reload();

    } catch (err) {
      console.error("Error during refresh/claim process:", err);
      // Provide a more specific error message to the user
      setError("We couldn't find your account in the directory. Please confirm with your church office that your email has been added, then try again.");
      setIsRefreshing(false); // Stop the loading indicator on error
    }
  };

  const handleLogout = () => {
    auth.signOut();
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card text-center shadow-sm border-danger">
            <div className="card-header bg-danger text-white">
              <FontAwesomeIcon icon={faExclamationTriangle} className="me-2"/> Account Not Found in Directory
            </div>
            <div className="card-body">
              <p className="card-text">
                You're almost there! Your email address (<strong>{currentUser?.email}</strong>) has been verified, but it was not found in the church directory.
              </p>
              <p>
                Please contact your church office to have your email added. Once it has been added, you can click the refresh button or log out and back in to gain access.
              </p>

              {/* Display any errors from the refresh process */}
              {error && <div className="alert alert-danger py-2 small"><FontAwesomeIcon icon={faExclamationTriangle} className="me-1"/> {error}</div>}

              {/* Centered container for primary action */}
              <div className="text-center mt-3">
                <button
                  className="btn btn-primary"
                  onClick={handleRefresh}
                  disabled={isRefreshing}
                >
                  <FontAwesomeIcon icon={faSync} className={`me-2 ${isRefreshing ? 'fa-spin' : ''}`}/>
                  {isRefreshing ? 'Refreshing...' : 'Refresh Status'}
                </button>
              </div>

              {/* Right-aligned container for logout, spaced down */}
              <div className="text-end mt-4">
                <button className="btn btn-danger" onClick={handleLogout} disabled={isRefreshing}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="me-2"/>Logout
                </button>
              </div>

            </div>
            <div className="card-footer text-muted small">
              This step is required to ensure only approved members can access the directory.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrgIdRequiredPrompt;